import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      email: null,
      displayName: null
    },
    flashMessage: null,
    deletedMessageId: null,
    allowActivity: true
  },
  mutations: {
    // synchronous
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.email = data.email;
      state.user.displayName = data.displayName;
    },
    SET_FLASH_MESSAGE(state, message) {
      state.flashMessage = message;
    },
    SET_DELETED_MESSAGE_ID(state, value) {
      state.deletedMessageId = value;
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    loggedIn(state) {
      return state.user.loggedIn;
    },
    completedLogin(state) {
      return (
        state.user.loggedIn &&
        state.user.displayName &&
        state.user.displayName.length > 0
      );
    },
    isAdmin(state) {
      return state.user.loggedIn && state.user.email.endsWith("@vectric.com");
    },
    flashMessage(state) {
      return state.flashMessage;
    },
    deletedMessageID(state) {
      return state.deletedMessageId;
    },
    allowActivity(state) {
      return state.allowActivity;
    }
  },
  actions: {
    setFlashMessage({ commit }, message) {
      commit("SET_FLASH_MESSAGE", message);
    },
    dismissFlashMessage({ commit }) {
      commit("SET_FLASH_MESSAGE", null);
    },
    setUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          email: user.email,
          displayName: user.displayName
        });
      }
    },
    setDeletedMessageId({ commit }, value) {
      commit("SET_DELETED_MESSAGE_ID", value);
    }
  },
  modules: {}
});
